// Motorpress v1 stress test - 19 pages cycled 28 times = 532 pages
const BASE = '/dev-content-files/pdf/motorpress-v1';

const pages = [
    { large: '1_v1_2095_2738_948a8a.jpg', thumb: '1_v1_392_512_948a8a.jpg', text: '1.html' },
    { large: '2_v1_2095_2732_797b7f.jpg', thumb: '2_v1_393_512_797b7f.jpg', text: '2.html' },
    { large: '3_v1_2095_2738_7c878b.jpg', thumb: '3_v1_392_512_7c878b.jpg', text: '3.html' },
    { large: '4_v1_2095_2738_90938c.jpg', thumb: '4_v1_392_512_8f928c.jpg', text: '4.html' },
    { large: '5_v1_2095_2738_97968e.jpg', thumb: '5_v1_392_512_97968e.jpg', text: '5.html' },
    { large: '6_v1_2095_2738_727980.jpg', thumb: '6_v1_392_512_72797f.jpg', text: '6.html' },
    { large: '7_v1_2095_2738_939899.jpg', thumb: '7_v1_392_512_939899.jpg', text: '7.html' },
    { large: '8_v1_2095_2738_7c7f75.jpg', thumb: '8_v1_392_512_7c7f75.jpg', text: '8.html' },
    { large: '9_v1_2095_2738_848581.jpg', thumb: '9_v1_392_512_848580.jpg', text: '9.html' },
    { large: '10_v1_2095_2738_858684.jpg', thumb: '10_v1_392_512_848684.jpg', text: '10.html' },
    { large: '11_v1_2095_2738_abacad.jpg', thumb: '11_v1_392_512_aaacad.jpg', text: '11.html' },
    { large: '12_v1_2095_2738_7b7c7b.jpg', thumb: '12_v1_392_512_7b7b7b.jpg', text: '12.html' },
    { large: '13_v1_2095_2738_bbbab9.jpg', thumb: '13_v1_392_512_bbbab9.jpg', text: '13.html' },
    { large: '14_v1_2095_2738_86898a.jpg', thumb: '14_v1_392_512_868989.jpg', text: '14.html' },
    { large: '15_v1_2095_2738_a2a39c.jpg', thumb: '15_v1_392_512_a2a39c.jpg', text: '15.html' },
    { large: '16_v1_2095_2738_7d8484.jpg', thumb: '16_v1_392_512_7c8484.jpg', text: '16.html' },
    { large: '17_v1_2095_2738_989c9d.jpg', thumb: '17_v1_392_512_989b9c.jpg', text: '17.html' },
    { large: '18_v1_2095_2738_9f9e9c.jpg', thumb: '18_v1_392_512_9f9e9c.jpg', text: '18.html' },
    { large: '19_v1_2095_2738_b2b2b2.jpg', thumb: '19_v1_392_512_b2b2b2.jpg', text: '19.html' },
];

const CYCLES = 28;

export default Array.from({ length: pages.length * CYCLES }, (_, i) => {
    const page = pages[i % pages.length];
    return {
        large: `${BASE}/large/${page.large}`,
        thumb: `${BASE}/thumb/${page.thumb}`,
        text_layer: `${BASE}/text-layer/${page.text}`,
        annotation_layer: null,
    };
});
